var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"copyright",style:(_vm.customStyle)},[_vm._v("© "+_vm._s(_vm.curYear)+" "+_vm._s(_vm.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }